import { React, useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Redirect, Switch } from "react-router-dom";
import Components from "./components/index";
import messageString from "./shared/messagestrip/index";
import { DefaultLayout } from "./layouts/index";
import "bootstrap/dist/css/bootstrap.min.css";
import { OrganizationProvider } from "./configurations/OrganizationContext";
import { orgConfig } from "./configurations/config";
import { helperServices } from "./shared/helper";
import { All_Component_Name, COMPONENT_TYPE_PAGE } from "./shared/constants";
import ProtectedComponent from "./components/common/ProtectedComponent";
import { UnauthorisedAcess } from "./components/common/UnauthorisedAcess";
import { loginServices } from "./core/services";
import { apiFetch } from "./shared/helper/apiFetch";
import GlobalLoader from "./shared/helper/GlobalLoader";
import BookingPlans from "./components/appointments/BookingPlans";
import BookingRecordView from "./components/appointments/BookingRecordView";
import BookingNewSession from "./components/appointments/BookingNewSession";
import Sessions from "./components/appointments/Sessions";
import CalendarView from "./components/appointments/CalendarView";
import EntityCreatePage from "./components/appointments/EntityCreatePage";
import Packages from "./components/appointments/Packages";
import GlobalShortcuts from "./keyboard/GlobalShortcuts";
import { ORG_CODES } from "./shared/constants";
let dischargeComponent = null;
let notesComponent = null;
export { notesComponent };

const getStoredRole = () => {
  const storedRole = localStorage.getItem("role");
  if (!storedRole) {
    return null;
  }

  try {
    return JSON.parse(storedRole);
  } catch (error) {
    return storedRole;
  }
};

const hasRole = (role, expectedRole) => {
  const roles = Array.isArray(role) ? role : [role];
  return roles
    .filter(Boolean)
    .some((item) => String(item).trim().toLowerCase() === expectedRole.toLowerCase());
};

// const org = process.env.REACT_APP_ORGANIZATION
// const DischargeComponent =
// org === "MNH" ? Components.MnhDischargeSummary : Components.Discharge;

// function App() {
//   window.onbeforeunload = null;
//   window.onbeforeunload = null;

//   // const org = process.env.REACT_APP_ORGANIZATION
//   // const DischargeComponent =
//   // org === "MNH" ? Components.MnhDischargeSummary : Components.Discharge;

//   console.log("org", org)
//   const orgSettings = orgConfig[org] || orgConfig.default;
//   console.log(`[Org Config] Current organization: ${org}`, {
//     config: orgSettings,
//     availableOrgs: Object.keys(orgConfig)
//   });

function App() {
  const [orgSettings, setOrgSettings] = useState(null); //   window.onbeforeunload = null;
  const [role, setRole] = useState(() => getStoredRole());
  window.onbeforeunload = null;

  useEffect(() => {
    const fetchOrgConfig = async () => {
      try {
        const data = await apiFetch("/api/v1/orgConfig");
        console.log("API Response:", data);
        setOrgSettings(data.orgConfigDetails);
         localStorage.setItem("orgCode", data.orgConfigDetails?.orgCode || "default");
        setRole(getStoredRole());
      } catch (err) {
        loginServices.logout();
      }
    };
    fetchOrgConfig();
  }, []);

  useEffect(() => {
    const handleCrossTabLogout = (event) => {
      const sessionWasCleared = event.key === null || event.key === "token";
      const isLoginPage = window.location.pathname.startsWith("/Login/");
      const isLoggedOut = !localStorage.getItem("token");

      if (
        sessionWasCleared &&
        isLoggedOut &&
        !isLoginPage &&
        window.location.pathname !== "/"
      ) {
        window.onbeforeunload = null;
        window.location.replace("/");
      }
    };

    const refreshRole = () => {
      const latestRole = getStoredRole();
      if (JSON.stringify(latestRole) !== JSON.stringify(role)) {
        setRole(latestRole);
      }
    };

    refreshRole();
    window.addEventListener("storage", handleCrossTabLogout);
    window.addEventListener("storage", refreshRole);
    window.addEventListener("focus", refreshRole);
    const roleRefreshInterval = setInterval(refreshRole, 500);

    return () => {
      window.removeEventListener("storage", handleCrossTabLogout);
      window.removeEventListener("storage", refreshRole);
      window.removeEventListener("focus", refreshRole);
      clearInterval(roleRefreshInterval);
    };
  }, [role]);

  // if (!orgSettings) {
  //   return (
  //     <div className="h-100 w-100 d-flex justify-content-center">
  //       <Components.Loading />
  //     </div>
  //   );
  // }
  
 /* dischargeComponent =
    orgSettings?.orgCode === "MNH"
      ? Components.MnhDischargeSummary
      : Components.Discharge;*/


  dischargeComponent =
  orgSettings?.orgCode === ORG_CODES.MNH
    ? Components.MnhDischargeSummary
    : orgSettings?.orgCode === ORG_CODES.VEDAMAAYU
    ? Components.VedamaayuDischargeSummary
    : Components.Discharge;

notesComponent =
  orgSettings?.orgCode === ORG_CODES.MNH
    ? Components.MnhNotes
    : orgSettings?.orgCode === ORG_CODES.VEDAMAAYU
    ? hasRole(role, "Nurse")
      ? Components.VedamaayuNurseNotes
      : Components.VedamaayuDoctorNotes
    : Components.Notes;

console.log("[NotesComponent]", {
  orgCode: orgSettings?.orgCode,
  role,
  selectedComponent:
    orgSettings?.orgCode === ORG_CODES.MNH
      ? "MnhNotes"
      : orgSettings?.orgCode === ORG_CODES.VEDAMAAYU
      ? hasRole(role, "Nurse")
        ? "VedamaayuNurseNotes"
        : "VedamaayuDoctorNotes"
      : "Notes (default)",
});
  return (
    <OrganizationProvider org={orgSettings}>
      <GlobalLoader /> {/* ← add this once */}
      <div className="h-100">
        <Route
          path="/"
          children={(routeProps) =>
            routeProps.match.isExact ? <Redirect to="/Login/:code" /> : ""
          }
        />
        <Route
          path={"/Login/:code"}
          render={(props) => <Components.Login {...props} />}
        />

        {/* Public routes that don't need access checking */}
        <Route path={"/AddPatient"} component={Components.AddPatientmodel} />
        <Route
          path={"/ZoomMeeting/:name/:meetingId/:patientId/:visitId/:groupId"}
          render={(props) => <Components.Zoom {...props} />}
        />

        {/* All routes go through MyLayout */}
        <Route path={"/Bed"} component={MyLayout} />
        <Route path={"/Admin"} component={MyLayout} />
        <Route path={"/Followup"} component={MyLayout} />
        <Route path={"/Assistant"} component={MyLayout} />
        <Route path={"/TokenDashBoard"} component={MyLayout} />
        <Route path={"/MyReports"} component={MyLayout} />
        <Route path={"/Appointments"} component={MyLayout} />
        <Route exact path="/FormDetail/:formId" component={MyLayout} />
        <Route path={"/AddForm"} component={MyLayout} />
        <Route path={"/Forms"} component={MyLayout} />
        <Route path={"/FormPreview"} component={MyLayout} />
        <Route path={"/Docsetup"} component={MyLayout} />
        <Route path={"/ListDoctor"} component={MyLayout} />
        <Route path={"/ListPatient"} component={MyLayout} />
        <Route path={"/Dashboard"} component={MyLayout} />
        <Route path={"/Settlements"} component={MyLayout} />
        <Route path={"/doctorregister"} component={MyLayout} />
        <Route path={"/adddoctor"} component={MyLayout} />
        <Route path={"/addstaff"} component={MyLayout} />
        <Route path={"/reports"} component={MyLayout} />
        <Route path={"/doctorlist"} component={MyLayout} />
        <Route path={"/StaffList"} component={MyLayout} />
        <Route path={"/staff/changePassword"} component={MyLayout} />
        <Route path={"/insurancemaster"} component={MyLayout} />
        <Route path={"/tpamaster"} component={MyLayout} />
        <Route path={"/insuremasterlist"} component={MyLayout} />
        <Route path={"/tpamasterlist"} component={MyLayout} />
        <Route path={"/roomMasterList"} component={MyLayout} />
        <Route path={"/roommaster"} component={MyLayout} />
        <Route path={"/ServiceMaster"} component={MyLayout} />
        <Route path={"/PatientSections/*"} component={MyLayout} />
        <Route exact path="/DiagnosisMaster/:patientId" component={MyLayout} />
        <Route path={"/Home"} component={MyLayout} />
        <Route path={"/Discharge"} component={MyLayout} />
        <Route path={"/Services"} component={MyLayout} />
        <Route path={"/message"} component={MyLayout} />
        <Route path={"/patient/"} component={Components.DoctorHomeView} />
        <Route
          exact
          path={"/procedure-list/:patientId/:visitId"}
          component={Components.StandaloneProcedureListing}
        />
        <Route
          path={"/notes/:patientid/:visitid/:groupid"}
          render={(props) => <Components.ZoomMeetingReviewModel {...props} />}
        />
        <Route path={"/PatientJson"} component={Components.PatientSchema} />
        <Route
          path={"/DischargeSummary/:patientid/:visitid"}
          component={MyLayout}
        />

        <Route 
          path={"/SurgeryConsentForm/:patientid/:visitid/:subgroup?"}
          component={MyLayout} 
        />

        <Route 
          path={"/AdmissionConsentForm/:patientid/:visitid/:subgroup?"}
          component={MyLayout} 
        />    

        <Route 
          path={"/PanchakarmaConsentForm/:patientid/:visitid/:subgroup?"}
          component={MyLayout} 
        />   

        <Route
          path={"/PainAssessmentForm/:patientid/:visitid/:subgroup?"}
          component={MyLayout}
        />

        <Route
          path={"/ZoomMeeting/:name/:meetingId/:patientId/:visitId/:groupId"}
          render={(props) => <Components.Zoommeeting {...props} />}
        />
        <Route
          path={"/PatientOneStepOnboard"}
          component={MyLayout}
        />
        <Route
          path={"/Payment/:name/:patientId/:visitId/:erpCustId"}
          component={Components.Payment}
        />
        <Route path={"/activeTokenPatients"} component={MyLayout} />
        <Route path={"/packageList"} component={MyLayout} />
        <Route path={"/labPackageList"} component={MyLayout} />
        <Route path={"/packageAdd"} component={MyLayout} />
        <Route path={"/billing/:patientId/:visitId"} component={MyLayout} />
        <Route path="/access-denied" component={MyLayout} />
        <Route path={"/roomManageDetails"} component={MyLayout} />
        <Route path={"/all/billing"} component={MyLayout} />
        <Route path={"/Patient_Profile_Print"} component={Components.BlobUrlViewer} />
        <Route exact path={"/BookingPlan"} render={() => <Redirect to="/booking-plans" />} />
        <Route path={"/booking-plans"} component={MyLayout} />
        <Route
  path={"/booking/new-session"}
  component={MyLayout}/>
  <Route path={"/packages"} component={MyLayout} />

<Route
  path={"/sessions"}
  component={MyLayout}
/>




<Route
  path={"/calendar"}
  component={MyLayout}
/>
      </div>
    </OrganizationProvider>
  );
}

function MyLayout() {
  return (
    <>
      <GlobalShortcuts />
      <DefaultLayout>
        <Switch>
        <Route
          path={"/PatientSections/:patientId/:visitId/new-booking/:id?"}
          component={BookingNewSession}
        />
        <Route
          exact
          path={"/PatientSections/:patientId/:visitId/consent-forms"}
          component={Components.ConsentFormsDashboard}
        />

        <Route
          exact
          path={"/PatientSections/:patientId/:visitId"}
          render={(props) => <Components.PatientSections {...props} />}
        />
        <Route
          path={"/PatientSections/new"}
          component={Components.PatientSections}
        />
        <Route
          path={"/Admin"}
          render={(props) => <Components.PatientListing {...props} />}
        />
        <Route path={"/Followup"} component={Components.PatientRevisit} />
        <Route
          exact
          path="/FormDetail/:formId"
          render={(props) => <Components.FormDetail {...props} />}
        />
        <Route path={"/AddForm"} component={Components.FormDetail} />
        <Route path={"/payment"} component={Components.Payment} />
        <Route
          path={"/paymentForClinic"}
          component={Components.PaymentForClinic}
        />
        <Route path={"/Forms"} component={Components.FormList} />
        <Route path={"/FormPreview"} component={Components.FormPreview} />
        <Route path={"/ListDoctor"} component={Components.ListDoctor} />
        <Route path={"/Docsetup"} component={Components.DocSetup} />
        <Route path={"/ServiceMaster"} component={Components.ServiceMaster} />
        <Route path={"/Dashboard"} component={Components.Dashboard} />
        <Route
          path={"/Settlements"}
          component={Components.InsuranceProcedureSettlement}
        />
        <Route path={"/doctorregister"} component={Components.DoctorRegister} />
        <Route path={"/adddoctor"} component={Components.addDoctor} />
        <Route path={"/doctorlist"} component={Components.DoctorList} />
        <Route path={"/StaffList"} component={Components.StaffList} />
        <Route path={"/addstaff"} component={Components.AddStaff} />
        <Route
          path={"/staff/changePassword"}
          component={Components.ChangePassword}
        />
        {/* <Route path={"/StaffListGrid"} component={Components.StaffListGrid}/> */}
        <Route
          path={"/insurancemaster"}
          component={Components.insuranceMasteradd}
        />
        <Route path={"/tpamaster"} component={Components.Tpaadd} />
        <Route
          path={"/insuremasterlist"}
          component={Components.insuranceMasterList}
        />
        <Route path={"/tpamasterlist"} component={Components.tpamasterlist} />
        <Route path={"/roomMasterList"} component={Components.roomMasterList} />
        <Route path={"/roommaster"} component={Components.RoomMasterAdd} />
        <Route path={"/reports"} component={Components.Reports} />
        <Route path={"/TokenDashBoard"} component={Components.TokenDashBoard} />
        <Route path={"/MyReports"} component={Components.MyReports} />
        <Route path={"/Appointments"} component={Components.AdminAppointment} />

            <Route path={"/packages"} component={Packages} />

<Route
  path={"/packages/new"}
  render={(props) => (
    <EntityCreatePage {...props} type="package" />
  )}
/>

<Route
  path={"/packages/edit/:id"}
  render={(props) => (
    <EntityCreatePage {...props} type="package" isEdit={true} />
  )}
/>

<Route
  exact
  path={"/booking-plans"}
  component={BookingPlans}
/>

<Route
  path={"/booking-plans/:id"}
  render={(props) => (
    <BookingRecordView {...props} type="plan" />
  )}
/>

<Route
  exact
  path={"/booking/new-session"}
  component={BookingNewSession}
/>
<Route
  path={"/booking/new-session/:id"}
  component={BookingNewSession}
/>
<Route
  path={"/sessions"}
  component={Sessions}
/>

<Route
  path={"/sessions/:id"}
  render={(props) => (
    <BookingRecordView {...props} type="session" />
  )}
/>

<Route 
  path={"/SurgeryConsentForm/:patientid/:visitid/:subgroup?"}
  component={Components.SurgeryConsentForm} 
/>
 
<Route 
  path={"/AdmissionConsentForm/:patientid/:visitid/:subgroup?"}
  component={Components.AdmissionConsentForm} 
/> 

<Route 
  path={"/PanchakarmaConsentForm/:patientid/:visitid/:subgroup?"}
  component={Components.PanchakarmaConsentForm} 
/> 

                  <Route
                    path={"/PainAssessmentForm/:patientid/:visitid/:subgroup?"}
                    component={Components.PainAssessmentForm}
                  />

<Route
  path={"/calendar"}
  component={CalendarView}
/>
                   <Route
          path={"/roomManageDetails"}
          component={Components.RoomManageDetails}
        />
        {/* <Route path={"/DischargeSummary/:patientid/:visitid"} component={Components.Discharge}/> */}
        <Route
          path={"/DischargeSummary/:patientid/:visitid"}
          component={dischargeComponent}
        />

        <Route path={"/Home"} component={Components.AdminHomeView} />
        <Route path={"/Discharge"} component={Components.Discharge} />
        <Route path={"/Services"} component={Components.Services} />
        <Route path={"/message"} component={messageString.MessageStrip} />
        <Route
          path={"/activeTokenPatients"}
          component={Components.ActiveTokenPatients}
        />
        <Route path={"/packageList"} component={Components.Package} />
        <Route path={"/labPackageList"} component={Components.labPackageList} />
        <Route path={"/addLabPackage"} component={Components.addLabPackage} />
        <Route path={"/packageAdd"} component={Components.PackageMasterAdd} />
 <Route path={"/PatientOneStepOnboard"} component={Components.PatientOneStepOnboard} />
        {/* Replace ConditionalRoute with regular route */}
        <Route
          path={"/billing/:patientId/:visitId"}
          render={(props) => (
            <ProtectedComponent
              componentName={All_Component_Name.BillingDashboard}
              component={Components.ERPBilling}
              pageType={COMPONENT_TYPE_PAGE}
              {...props} 
            />
          )}
        />

        {/* Add access denied route */}
        <Route path="/access-denied" render={() => <UnauthorisedAcess />} />
        <Route
          path={"/all/billing"}
          component={Components.AllCustomerInvoicePaymentRequest}
        />
        </Switch>
      </DefaultLayout>
    </>
  );
}

App.propTypes = {};
export default App;
